import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet'
import Carousel, { Modal, ModalGateway } from 'react-images'
import styles from './story.module.scss'

const carouselNavStyles = (base) => ({
    ...base,
    'zIndex': 10,
    ':hover': {
        backgroundColor: '#009A3A',
    },
})

const carouselStyles = {
    navigationNext: carouselNavStyles,
    navigationPrev: carouselNavStyles,
    container: (base) => ({
        ...base,
        zIndex: 1000,
    }),
}

const NavButton = ({ align, innerProps }) => {
    return (
        <div
            className={
                align == 'right'
                    ? styles.storyLightboxButton
                    : styles.storyLightboxButtonLeft
            }
            {...innerProps}
        >
            <img src={require('../../images/story-slide/arrow-icon.svg')} />
        </div>
    )
}

const ImageView = (props) => {
    const { data, index, views } = props
    return (
        <div className={styles.storyLightboxView}>
            <div>
                <img src={data.source} alt={data.alt} />
                <div className={styles.storyLightboxInfo}>
                    <span className={styles.storyLightboxCount}>
                        {index + 1}/{views.length}
                    </span>
                    <p
                        className={styles.storyLightboxCaption}
                        dangerouslySetInnerHTML={{ __html: data.caption }}
                    />
                </div>
            </div>
        </div>
    )
}

const Lightbox = ({ images, open, onClose }) => (
    <>
        <Helmet
            style={[
                {
                    cssText: `
                .react-images__track {
                    transition: all linear 0.2s;
                }
            `,
                },
            ]}
        />
        <ModalGateway>
            {open ? (
                <Modal onClose={onClose}>
                    <Carousel
                        styles={carouselStyles}
                        views={images}
                        components={{
                            Footer: () => null,
                            FooterCaption: () => null,
                            FooterCount: () => null,
                            HeaderFullscreen: () => null,
                            NavigationNext: NavButton,
                            NavigationPrev: NavButton,
                            View: ImageView,
                        }}
                    />
                </Modal>
            ) : null}
        </ModalGateway>
    </>
)

export default Lightbox
